// extracted by mini-css-extract-plugin
export default {"component":"bUBLI","name":"lSuWk","date":"grweo","active":"wpns0","text":"WsGVn","address":"gCz3Q","opening":"klpRq","metro":"pcJvM","wrapper":"ZVQzv"};